import { render, staticRenderFns } from "./DissolutionSheet.vue?vue&type=template&id=159b6333&"
import script from "./DissolutionSheet.vue?vue&type=script&lang=js&"
export * from "./DissolutionSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports